
export class FetchOrganizationSelection {
  static readonly type = '[OrganizationSelection] FetchOrganizationSelection';
}
